// function ThankYouPageCandidate() {
//   return (
//     <div className="container-fluid" id="skill_section">
//       <div className="row mt-5">
//         <div className="col-sm-10 offset-sm-1 expired-div">
//           <p className="text-center pt-4">
//             <p>
//               Thank you for submiting your details. If you have any question you
//               can get in touch with HR department.
//             </p>
//           </p>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default ThankYouPageCandidate;
function ThankYouPageCandidate() {
  return (
    <div style={{
      backgroundColor: '#f8f9fa',
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      padding: '20px 0'
    }}>
      <div style={{
        width: '100%',
        maxWidth: '800px',
        margin: '0 auto',
        padding: '30px'
      }}>
        <div style={{
          backgroundColor: 'white',
          borderRadius: '10px',
          padding: '30px',
          boxShadow: '0 5px 15px rgba(0,0,0,0.1)',
          textAlign: 'center',
          borderLeft: '5px solid #27568B',
          position: 'relative',
          overflow: 'hidden'
        }}>
          <div style={{
            position: 'absolute',
            top: '0',
            left: '0',
            width: '100%',
            height: '5px',
            background: 'linear-gradient(90deg, #27568B, #2E7D32)'
          }}></div>
          
          <h3 style={{
            color: '#27568B',
            marginBottom: '20px',
            fontWeight: '600'
          }}>Thank You for Submitting Your Details!</h3>
          
          <p style={{
            fontSize: '1.1rem',
            lineHeight: '1.6',
            color: '#555',
            marginBottom: '25px'
          }}>
            If you have any questions, 
            you can get in touch with our HR department.
          </p>
          
          <div style={{
            backgroundColor: '#f1f8e9',
            padding: '15px',
            borderRadius: '8px',
            margin: '20px 0',
            borderLeft: '3px solid #27568B'
          }}>
            <p style={{
              margin: '0',
              color: '#33691E',
              fontWeight: '500'
            }}>
              We appreciate your interest in joining our team and will review 
              your Details carefully.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ThankYouPageCandidate;
